(function () {
  'use strict';

  var DISMISS_DELAY = 4000;
  var dismissTimer = null;

  function show(product, productTitle) {
    var notif = document.getElementById('swymcs-global-custom-notification');
    if (!notif) return;

    var titleEl = document.getElementById('swymcs-notif-product-title');
    var imgEl = notif.querySelector('.swymcs-notif-img-wrapper img');

    var title = productTitle || product.dt || '';
    if (titleEl) titleEl.textContent = title;
    if (imgEl) {
      imgEl.src = product.iu || '';
      imgEl.alt = title;
    }

    notif.classList.remove('swym-hide-container');
    notif.classList.remove('swymcs-notif-slide-in');
    void notif.offsetWidth; // force reflow so animation restarts if already visible
    notif.classList.add('swymcs-notif-slide-in');

    clearTimeout(dismissTimer);
    dismissTimer = setTimeout(function () {
      notif.classList.add('swym-hide-container');
      notif.classList.remove('swymcs-notif-slide-in');
    }, DISMISS_DELAY);
  }

  function init(swat) {
    var notif = document.getElementById('swymcs-global-custom-notification');
    if (!notif) return;

    document.getElementById('swymcs-custom-notif-close-button')
      ?.addEventListener('click', function () {
        notif.classList.add('swym-hide-container');
        notif.classList.remove('swymcs-notif-slide-in');
        clearTimeout(dismissTimer);
      });

    swat.evtLayer.addEventListener('sw:addedtowishlist', function (e) {
      var product = (e.detail && e.detail.d) ? e.detail.d : {};
      var btn = document.querySelector('[data-product-id="' + product.empi + '"][data-product-title]');
      var productTitle = btn ? btn.getAttribute('data-product-title') : null;
      show(product, productTitle);
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(init);
})();
